<template>
  <div class="columnList">
    <!-- <div class="columnListCommorCont crumbs"><a href="/">Home</a> > show</div> -->
    <!-- 主要内容 -->
    <div class="columnListCommorCont columnListWrap">
      <!-- left -->
      <div class="wrap-left">
        <h1 class="article-title" data-programid="50" data-type="other">
          {{programTitle}}
        </h1>
        <!-- ---- -->
        <div class="show-pic">
          <img :src="programUrl" :alt="programTitle" />
          <i class="show-pic-play" :data-id="firstList.programId" data-type="mp3" :data-title="firstList.title" :data-date="firstList.day" :data-time="firstList.time" :data-img="firstList.programUrl" :data-program-title="firstList.programTitle" :data-url="firstList.mediaUrl" @click="play($event, true)"></i>
        </div>
        <!-- -- -->
        <h2 class="showpage-title" id="pagemap">栏目介绍</h2>
        <div class="showpage-txt">
          <p v-html="info">
            {{ info }}
          </p>
        </div>
        <!-- 分享 -->
        <div class="widget-share">
          <strong>分享至：</strong>
          <a href="javascript:void(0)" class="weixin" @click.stop.prevent="" @click="isWxCode = !isWxCode"></a>
          <a :href="wbShareLink" class="weibo" target="_blank"></a>
          <a :href="qqShareLink" class="qq" target="_blank"></a>
          <div class="code wxCode" id="qrcode" ref="qrcode" v-show="isWxCode">
          </div>
        </div>
        <!--  -->
        <ul class="showpage-tab">
          <li class="current">All Episodes</li>
          <!-- <li>Clips</li> -->
        </ul>
        <!-- ===== -->
        <div class="showpage-tab-con">
          <ul class="showpage-tab-list" id="js-showplaylist">
            <li class="" v-for="(item, index) in allList" :key="index">
              <i
                class="item-playbtn"
                data-status="1"
                :data-id="item.programId"
                data-type="mp3"
                :data-title="item.title"
                :data-date="item.day"
                :data-time="item.time"
                :data-img="item.programUrl"
                :data-program-title="item.programTitle"
                :data-url="item.mediaUrl"
                data-announcer=""
                @click="play($event, true)"
              ></i>
              <h4 class="item-title">
                <router-link :to="'/columnList/'+routerType+'/'+item.programId">{{ item.title }}</router-link>
              </h4>
              <span class="item-time" v-html="item.duration"></span
              ><span class="item-info" @click="addList($event)"
                ><a href="javascript:void(0);" class="add" title="添加"></a
              ></span>
            </li>
          </ul>
          <!-- v-show="totalRow > 0" -->
          <v-page
            ref="page"
            :total-row="parseInt(totalRow) * 10"
            class="myPaging"
            align="center"
            @page-change="pageChange"
            :page-size-menu="false"
            :info="false"
            :first="false"
            :last="false"
          ></v-page>
        </div>
      </div>
      <!-- right -->

      <div class="wrap-right">
        <div class="spread">
          <a :href="adInfoUrl" target="_blank"><img :src="adImageUrl" /></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  name: "ColumnList",
  data() {
    return {
      totalRow: 0,

      msg: "columnList",
      allList: [],
      firstList:[],
      programId: "",
      status:'',
      programTitle:"",
      //number  页面有两个接口 第二个接口需要穿的  虽然参数名一样
      number: "",
      // 写死的值 后台要求
      category: 1,
      //sort 默认后台排序
      sort: 0,
      info: "",
      page: 1,
      // categoryId: "",
      programUrl: "",
      type: 1,
      routerType:null,
      //右侧图片
      adImageUrl: "",
      //右侧图片 url
      adInfoUrl: "",
      //右侧图片title
      title: "",
      pInfo: {
        pageSize: 50,
      },
      objzidian: {
        ezfm: 1,
        ezfmSelection: 2,
        recommend: 3,
        more: 4,
        other: 5,
        otherSelection: 6,
        otherHistory: 5,
        ezfmHistory: 1,
      },
      zidianCategory: {
        other: 5,
        ezfm: 1,
        5:5,
        1:1,
      },
      // 分享链接
      qqShareLink:'',
      wbShareLink:'',
      curPageLink:window.location.href,
      isWxCode:false,
    };
  },
  methods: {
    //根据来源 调取不同接口
    getSource() {
      var _this = this;
      //如果 从shows 来源
      _this.programId = parseInt(_this.$route.params.newsId);
      console.log(_this.programId)
      var type = _this.$route.params.type;
      _this.routerType = _this.zidianCategory[_this.$route.params.type + ""];
      console.log(type)
      if (type == '1' || type == '5') {
        _this.type = _this.$route.params.type;
        _this.category = _this.$route.params.type;
        _this.getList();
      }else{
        _this.type = _this.objzidian[_this.$route.params.type + ""];
        _this.category = _this.zidianCategory[_this.$route.params.type + ""];
        _this.newGetList(1);
      }
    },
    newGetList(page) {
      var _this = this , dayArr = [] , _day = '';
      if(_this.programId){
        // 请求接口传参 https://aezfm.meldingcloud.com/program/historyList?category=5&programId=159&page=1
        _this.$http
          .post("/qertyuiy/program/historyList?programId="+_this.programId+"&page="+page+"&category="+_this.category+"&pageSize=50")
          .then(function (res) {
            _this.totalRow = parseInt(res.data.totalPage);
            // 栏目列表
            for(var i=0;i<res.data.data.length;i++){
              if(res.data.data[i].day){
                dayArr = res.data.data[i].day.split('-');
                switch(dayArr[1]){
                  case '01':
                    dayArr[1] = 'Jan';
                    break;
                  case '02':
                    dayArr[1] = 'Feb';
                    break;
                  case '03':
                    dayArr[1] = 'Mar';
                    break;
                  case '04':
                    dayArr[1] = 'Apr';
                    break;
                  case '05':
                    dayArr[1] = 'May';
                    break;
                  case '06':
                    dayArr[1] = 'Jun';
                    break;
                  case '07':
                    dayArr[1] = 'Jul';
                    break;
                  case '08':
                    dayArr[1] = 'Aug';
                    break;
                  case '09':
                    dayArr[1] = 'Sept';
                    break;
                  case '10':
                    dayArr[1] = 'Oct';
                    break;
                  case '11':
                    dayArr[1] = 'Nov';
                    break;
                  case '12':
                    dayArr[1] = 'Dec';
                    break;
                  default:
                    dayArr[1] = '';
                }
                _day = dayArr[1]+'&nbsp;'+dayArr[2]+',&nbsp;'+dayArr[0];
              }else{
                _day = '';
              }
              res.data.data[i].duration ? res.data.data[i].duration = _day+'&nbsp;|&nbsp;'+res.data.data[i].duration : res.data.data[i].duration = _day;
              
            }
            _this.allList = res.data.data;
            _this.firstList = res.data.data[0];
            // 栏目名
            _this.programTitle = _this.firstList.programTitle;
            // //图片
            _this.programUrl = res.data.logoUrl;
            // // 栏目介绍
            if(res.data.info != 'undefined' && res.data.info != '' && res.data.info != undefined){
              if(res.data.info.indexOf('\n') != -1){
                _this.info = res.data.info.replace(/\n/g,"<br>");
              }else{
                _this.info = res.data.info;
              }
            }
            // //右侧广告图片
            _this.adImageUrl = res.data.adImageUrl;
            // //Y右侧广告url
            _this.adInfoUrl = res.data.adImageUrl;
            _this.qqShareLink = 'http://connect.qq.com/widget/shareqq/index.html?title='+_this.programTitle+'&pics='+_this.programUrl+'&url='+_this.curPageLink+'';
            _this.wbShareLink = 'http://service.weibo.com/share/share.php?title='+_this.programTitle+'&pic='+_this.programUrl+'&url='+_this.curPageLink+'';
            // //右侧图片 title
            // _this.title = res.data.title;
            document.title = _this.programTitle;
            $("meta[name='description']").attr('content',''+res.data.info+'');
          });
      }
      
    },
    // 获取 左右侧图片 info src 等信息
    getList() {
      var _this = this;
      if(_this.programId){
        // 从shows 过来 type 就是1  泳道过来 那就是传参的 字典查询  而且 category值也变
        // 请求接口传参 https://aezfm.meldingcloud.com/program/onAir?programId=252862&type=1
        _this.$http
          .post(
            "/qertyuiy/program/onAir?programId=" +
              _this.programId +
              "&type=" +
              _this.type
          )
          .then(function (res) {
            if(res.data.data.startTime != '' && res.data.data.stopTime != ''){
              res.data.data.time = res.data.data.startTime+'-'+res.data.data.stopTime
            }
            _this.firstList = res.data.data;
            // //根据这个id 去请求
            _this.number = res.data.data.programId;
            //图片
            _this.programUrl = res.data.data.programUrl;
            // 栏目介绍
            if(res.data.data.info != 'undefined' && res.data.data.info != '' && res.data.data.info != undefined){
              if(res.data.data.info.indexOf('\n') != -1){
                _this.info = res.data.data.info.replace(/\n/g,"<br>");
              }else{
                _this.info = res.data.data.info;
              }
            }
            _this.info = res.data.data.info.replace(/\n/g,"<br>");
            //右侧广告图片
            _this.adImageUrl = res.data.data.adImageUrl;
            //Y右侧广告url
            _this.adInfoUrl = res.data.data.adImageUrl;
            //右侧图片 title
            // _this.title = res.data.data.title;
            // 栏目名
            _this.programTitle = res.data.data.title;
            _this.qqShareLink = 'http://connect.qq.com/widget/shareqq/index.html?title='+_this.programTitle+'&pics='+_this.programUrl+'&url='+_this.curPageLink+'';
            _this.wbShareLink = 'http://service.weibo.com/share/share.php?title='+_this.programTitle+'&pic='+_this.programUrl+'&url='+_this.curPageLink+'';
            document.title = _this.programTitle;
            $("meta[name='description']").attr('content',''+res.data.data.info+'');
            _this.gethistoryList(1);
          });
      }
    },
    gethistoryList(pageNumber) {
      
      var _this = this , dayArr = [] , _day = '';
      if(_this.number){
        // 请求接口传参 https://aezfm.meldingcloud.com/program/historyList?category=1&programId=12&page=1&sort=0&pageSize=20
      _this.$http
        .post("/qertyuiy/program/historyList?&page="+pageNumber+"&category="+_this.category+"&sort="+_this.sort+"&pageSize=50&programId="+_this.number)
        .then(function (res) {   
          //总条数 栏目列表总条数
          _this.totalRow = parseInt(res.data.totalPage);
          // 栏目列表
          for(var i=0;i<res.data.data.length;i++){
            if(res.data.data[i].day){
              dayArr = res.data.data[i].day.split('-');
              switch(dayArr[1]){
                case '01':
                  dayArr[1] = 'Jan';
                  break;
                case '02':
                  dayArr[1] = 'Feb';
                  break;
                case '03':
                  dayArr[1] = 'Mar';
                  break;
                case '04':
                  dayArr[1] = 'Apr';
                  break;
                case '05':
                  dayArr[1] = 'May';
                  break;
                case '06':
                  dayArr[1] = 'Jun';
                  break;
                case '07':
                  dayArr[1] = 'Jul';
                  break;
                case '08':
                  dayArr[1] = 'Aug';
                  break;
                case '09':
                  dayArr[1] = 'Sept';
                  break;
                case '10':
                  dayArr[1] = 'Oct';
                  break;
                case '11':
                  dayArr[1] = 'Nov';
                  break;
                case '12':
                  dayArr[1] = 'Dec';
                  break;
                default:
                  dayArr[1] = '';
              }
              _day = dayArr[1]+'&nbsp;'+dayArr[2]+',&nbsp;'+dayArr[0];
            }else{
              _day = '';
            }
            res.data.data[i].duration ? res.data.data[i].duration = _day+'&nbsp;|&nbsp;'+res.data.data[i].duration : res.data.data[i].duration = _day;
            
          }
          _this.allList = res.data.data;
          // _this.firstList = res.data.data[0];
        });
      }
    },
    pageChange(pInfo) {
      var _this = this;
      var type = _this.$route.params.type;
      if (type == '1' || type == '5') {
        _this.gethistoryList(pInfo.pageNumber);
      } else {
        _this.newGetList(pInfo.pageNumber);
      }
      _this.$nextTick(function(){
        $('#js-showplaylist li .item-playbtn').removeClass('js-play');
      })
    },
    reType:function(type) {
      var _type = type || 'application/x-mpegURL';
      switch (_type) {
          case 'live':
              _type = 'application/x-mpegURL';
              break;
          case 'mp3':
              _type = 'audio/mpeg';
              break;
          default:
              break;
      }
      return _type;
    },
    play: function (event) {
      var _this = this,
        _el = $(event.currentTarget),
        _curPage = $(_this.$parent.$children[3].$el);
      if (_curPage.attr("class") != "player") {
        _this.$parent.$children[2].audioPlay(_el, true);
      } else {
        _this.$parent.$children[3].audioPlay(_el, true);
      }
    },
    addList:function(event){
      var _self = this , _el = $(event.currentTarget) , _curPage = $(_self.$parent.$children[3].$el);
      var _parent = _el.parents();
      var num = $('#js-showplaylist li').index(_parent[0]);
      var _this = $('#js-showplaylist li:eq(' + num + ') .item-playbtn');
      var status = _this.attr('data-status');
      if (status === 'true' || status === '1') {
          var data = {
              title: _this.attr('data-title') || '',
              date: _this.attr('data-date') || '0000-00-00',
              time: _this.attr('data-time') || '00:00-23:59',
              announcer: _this.attr('data-announcer') || '',
              type: _self.reType(_this.attr('data-type')),
              url: _this.attr('data-url') || '#'
          };
          //调用加入播放列表方法
          if (_curPage.attr("class") != "player") {
            _self.$parent.$children[2].addPlayList(data);
          } else {
            _self.$parent.$children[3].addPlayList(data);
          }
      } else {
          alert('节目因版权原因不可收听');
      }
    },
    // 生成二维码
    wxCode:function(){
      var _this = this;
      _this.qrcode = new QRCode('qrcode', {
        text:_this.curPageLink,
        width:100,
        height: 100,
      });
    },
  },
  beforeCreate() {},

  created: function () {
    
  },
  mounted: function () {
    var _this = this;
    this.getSource();
    this.wxCode();
    $(document).on('click',function(event){
        var _con = $('.weixin');
        if(!_con.is(event.target) && _con.has(event.target).length === 0){ // Mark 1
          _this.isWxCode = false;
        }
    })
  },
};
</script>
<style  lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body,
html {
  width: 100%;
  height: 100%;
}
p {
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}

.columnList {
  background-color: #f3f4f5;
}
.columnListCommorCont {
  width: 1280px;
  margin: 0 auto;
}
// 导航栏
.crumbs {
  font-size: 14px;
  color: #999;
  height: 64px;
  line-height: 54px;
  a {
    font-size: 14px;
    color: #999;
  }
}
// 主要内容
.columnListWrap {
  display: flex;
  margin-top: 30px;
  padding-bottom: 30px;
}
.wrap-left {
  width: 784px;
  margin-right: 32px;
  .article-title {
    margin-top: 0;
    padding: 0;
    font-size: 26px;
    line-height: 38px;
    font-weight: normal;
  }
  //datu
  .show-pic {
    position: relative;
    width: 780px;
    height: 520px;
    margin: 10px auto 0;
    img {
      height: 100%;
      width: 100%;
      display: block;
    }
    i.show-pic-play {
      background: url(/static/img/sprite-icon.628f75d.png) no-repeat;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 76px;
      height: 76px;

      margin-left: -38px;
      margin-top: -38px;
      background-position: -150px -80px;
      background-size: auto;
      cursor: pointer;
    }
  }
  //
  .showpage-title {
    margin-top: 25px;
    font-size: 18px;
    font-weight: normal;
    padding: 0px 10px;
  }
  //
  .showpage-txt {
    margin-top: 10px;
    color: #999;
    padding: 0px 10px;
  }
  // 分享
  .widget-share {
    display: flex;
    padding: 0px 10px;
    height: 21px;
    line-height: 21px;
    margin-top: 14px;
    position: relative;
    strong {
      // float: left;
      padding-right: 30px;
      font-weight: normal;
      color: #999;
      font-size: 14px;
    }
    a {
      cursor: pointer;
      width: 25px;
      height: 21px;
      margin-right: 15px;
      background: url("../../static/img/sprite-icon.png");
    }
    a.weixin {
      background-position: -300px 0px;
    }
    a.weixin:hover {
      background-position: -300px -30px;
    }
    a.weibo {
      background-position: -329px 0px;
    }
    a.weibo:hover {
      background-position: -329px -30px;
    }
    a.qq {
      background-position: -359px 0px;
    }
    a.qq:hover {
      background-position: -359px -30px;
    }
    .wxCode{position: absolute;z-index: 999;top: 30px;left: 50px;}
  }
  //
  .showpage-tab {
    height: 47px;
    margin-top: 24px;
    border-bottom: solid 1px #dcdee3;
    li {
      float: left;
      height: 47px;
      padding: 0 10px;
      color: #0085cc;
      line-height: 47px;
      font-size: 24px;
      margin-right: 20px;
      cursor: pointer;
    }
    li.current {
      background-color: #0085cc;
      color: #fff;
    }
  }
  //----
  .showpage-tab-list {
    li {
      zoom: 1;
      display: block;
      position: relative;

      font-size: 14px;
      line-height: 34px;
      box-sizing: border-box;
      border-bottom: dashed 1px #dcdee3;
      padding: 28px 10px;
      width: 100%;

      .item-playbtn {
        background: url("../../static/img/sprite-icon.png") no-repeat;
        position: absolute;
        left: 10px;
        top: 28px;
        width: 34px;
        height: 34px;
        margin-right: 30px;
        background-position: -300px -100px;
        cursor: pointer;
      }
      //---
      .item-title {
        float: left;
        font-weight: normal;
        margin-left: 74px;
        width: 72%;
        padding-right: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        a {
          color: #333;
          text-decoration: none;
        }
        a:hover{color: #0085cb;}
      }
      .item-time {
        color: #999;
        float: right;
      }
      //
      .item-info {
        cursor: pointer;
        background: url("../../static/img/sprite-icon.png") no-repeat;
        background-position: -300px -140px;
        display: none;
        width: 25px;
        height: 24px;
        float: right;
        margin-top: 5px;
        margin-right: 20px;
      }
    }
    li:after {
      content: ".";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    li:hover .item-playbtn {
      background-position: -340px -100px;
    }
    li:hover .item-time {
      display: none;
    }
    li:hover .item-info {
      display: block;
    }
  }
}

//right
.wrap-right {
  width: 464px;
  .spread {
    img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 900px) {
  .columnList {
    background: #fff;
    .crumbs {
      display: none;
    }
  }
  .columnListCommorCont {
    width: 100%;
    min-width: 100%;
  }
  .columnListWrap {
    width: 100%;
    display: block;
    margin-top: .3rem;
    .wrap-right {
      display: none;
    }
    .wrap-left {
      width: 100%;
      margin-right: 0;
      .article-title {
        margin-top: 0;
        padding: 0 10px;
        font-size: 16px;
        line-height: 20px;
        font-weight: normal;
      }
      .show-pic {
        position: relative;
        width: 100%;
        height: auto;
        margin: 10px auto 0;
        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }
      // ----
      .showpage-title {
        margin-top: 25px;
        font-size: 18px;
        font-weight: normal;
        padding: 0px 10px;
      }
      // ---
      .showpage-txt {
        margin-top: 10px;
        color: #999;
        padding: 0px 10px;
        font-size: 0.28rem;
      }
      // ---
      .showpage-tab-con {
        li {
          zoom: 1;
          display: block;
          position: relative;
          padding: 10px 10px;
          font-size: 14px;
          line-height: 24px;
          border-bottom: dashed 1px #dcdee3;
          .item-playbtn {
            position: absolute;
            left: 10px;
            top: 10px;
            width: 34px;
            height: 34px;
            margin-right: 30px;
            background-position: -300px -100px;
            cursor: pointer;
          }
          // --
          .item-title {
            font-weight: normal;
            margin-left: 74px;
            width: 76%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .item-time {
            float: left;
            display: block;
            color: #999;
            margin-left: 74px;
          }
          .item-info {
            display: none;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/ColumnList.vue